<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="域名：" prop="host">
                <span>{{model.host}}</span>
            </el-form-item>
            <el-form-item label="IP地址：" prop="ip">
                <span>{{model.ip}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'hostListInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                host: '',
                ip: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/hostlist/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>